"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var flexibleLayout_1 = require("../../utility/flexibleLayout");
var Spinner = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.height, height = _c === void 0 ? 80 : _c, _d = _a.size, size = _d === void 0 ? 32 : _d, color = _a.color, className = _a.className;
    return ((0, jsx_runtime_1.jsx)(Root, __assign({ className: className, style: {
            width: width,
            height: height
        } }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(core_1.CircularProgress, { size: size, color: color }) }) })));
};
var Root = (0, styles_1.styled)('div')(__assign(__assign({}, (0, flexibleLayout_1.flexibleLayoutContainer)({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center'
})), { lineHeight: 0 }));
exports["default"] = Spinner;
